import { render, staticRenderFns } from "./FulfillmentStockRequests.vue?vue&type=template&id=71e40a39"
import script from "./FulfillmentStockRequests.vue?vue&type=script&lang=js"
export * from "./FulfillmentStockRequests.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentStockRequests.vue?vue&type=style&index=0&id=71e40a39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports